// Datos de contacto — fuente única para toda la web.
// strings.ts es solo copy (labels); esto es data (números, emails y sus hrefs).
// El email oficial es profind.soporte@gmail.com (alineado con los docs legales y mobile).
// El teléfono es el mismo número de WhatsApp: se usa como tel: (llamar) y wa.me (chat).

const PHONE_E164 = '+5492616303249'; // tel: — formato E.164 sin espacios
const WHATSAPP_DIGITS = '5492616303249'; // wa.me — solo dígitos
const EMAIL = 'profind.soporte@gmail.com';

export const contact = {
  email: EMAIL,
  emailHref: `mailto:${EMAIL}`,
  phoneDisplay: '+54 9 2616 30 3249',
  phoneHref: `tel:${PHONE_E164}`,
  whatsappDisplay: '+54 9 2616 30 3249',
  whatsappHref: `https://wa.me/${WHATSAPP_DIGITS}`,
} as const;
